import React from 'react';
import PropTypes from "prop-types";
import APPCONFIG from "../../constants/Config";

export default class DispositionSignatures_v2 extends React.Component {
	static propTypes = {
		signature: PropTypes.object.isRequired,
	};

	render() {
		/**
		 * @type {Signatures_Object}
		 */
		let signature = this.props.signature;

		return <div className={'col-6 offset-3'} style={{
			textAlign: "center",
			marginBottom: "5px",
			border: "1px solid #e8e8e8",
			borderRadius: "5px",
			boxShadow: "0 1px 4px rgba(0, 0, 0, 0.27), 0 0 40px rgba(0, 0, 0, 0.08) inset"
		}}>
			<img
				src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/customers/' + '0001-9999999' + '/identifications/' + '0001-95' + '/images?image=' + signature.signature}
				alt={signature.signature_location}
				style={{maxWidth: '100%'}}
			/>
			<br/>
			<p style={{color: "#C3C3C3"}}>{signature.transaction_signature_locations.name}</p>
		</div>
	}
}

